import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">焦点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选热门内容专题，一站直达品质观影</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative bg-background-100 rounded-lg border border-background-200/60 overflow-hidden cursor-pointer hover:border-primary-300/60 transition-all"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-2 whitespace-nowrap">
                    {item.subtitle}
                  </span>
                  <h3 className="text-lg font-bold text-background-50 mb-1">{item.title}</h3>
                  <p className="text-sm text-background-50/80 leading-relaxed">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}